module.exports = __webpack_public_path__ + "static/media/Picture4.80ed7b92.jpg";